// dashboard.component.ts
import { Component, OnInit } from '@angular/core';
import { faUserPlus, faHome, faNewspaper, faCubes } from '@fortawesome/free-solid-svg-icons';
import { AppService } from '@services/app.service';
import { BlogService } from '@services/blog.service';
import { PortfolioService } from '@services/portfolio.service';
import { UserService } from '@services/user.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  // faBookmark = faBookmark;
  // faEnvelope = faEnvelope;
  // faChartSimple = faChartSimple;
  // faCartShopping = faCartShopping;
  // faChartPie = faChartPie;

  faUserPlus = faUserPlus;
  faPaper = faNewspaper;
  faHome = faHome;
  faCubes = faCubes;

  blogCount: number = 0;
  userCount: number = 0;
  homeCount: number = 0;
  projectCount: number = 0;


  constructor(
    private appService: AppService,
    private blogSvc: BlogService,
    private userSvc: UserService,
    private portFolioService: PortfolioService

  ) {
    this.appService.getProfile();
  }

  ngOnInit(): void {
    this.getBlogCount().then(count => this.blogCount = count);
    this.getUserCount().then(count => this.userCount = count);
    this.getProjectCount().then(count => this.projectCount = count);
  }

  // Get Blog Count
  /**
   * @returns {number} - Returns the number of blogs
   */
  getBlogCount(): Promise<number> {
    return this.blogSvc.getAllBlogs().then((blogs) => {
      return blogs.length;
    });
  }

  // Get User Count
  /**
   * @returns {number} - Returns the number of users
   */
  getUserCount(): Promise<number> {
    return this.userSvc.getCollection$().then((users) => {
      return users.length;
    });
  }

  /**
   * Get Project Portfolio Count
   * @returns {number} - Returns the number of projects
   */
  getProjectCount(): Promise<number> {
    return this.portFolioService.getCollection$().then((projects) => {
      return projects.length;
    });
  }
}
